import React from 'react'

export default function Gandhimandelalegacy() {
  return (
    <div>Gandhimandelalegacy</div>
  )
}
